import FacilityInfo from "@/views/reporting/TransferStation/FacilityInfo.vue";
import Materials from "@/views/reporting/TransferStation/Materials.vue";

export default {
    FacilityInfo,
    Materials
}